export default "__VITE_ASSET__sqi9bJeJ__"